import { LifeBuoy } from "lucide-react";

const CrisisBanner = () => (
  <div
    data-testid="crisis-banner"
    className="w-full bg-[#C77B5A] text-white text-sm"
  >
    <div className="max-w-6xl mx-auto px-4 py-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-center">
      <LifeBuoy className="w-4 h-4 shrink-0" />
      <span className="font-medium">
        In crisis or thinking of self-harm? You are not alone — please reach out now:
      </span>
      <span className="font-semibold">
        Tele-MANAS <a href="tel:14416" className="underline underline-offset-2">14416</a> · iCall · AASRA
      </span>
    </div>
  </div>
);

export default CrisisBanner;
